export const STATIC_FETCH_URL = 'http://server-api.belegunsgsplan.com/api/v1'

export const INIT_SESSION_URL = `${STATIC_FETCH_URL}/sessions`
export const GET_DATA_BY_SESSION_URL = `${STATIC_FETCH_URL}/sessions`
export const GET_CODE_ROOM_URL = `${STATIC_FETCH_URL}/sessions/room`
export const CONFIRM_BOOKED_URL = `${STATIC_FETCH_URL}/sessions/room/confirm`
export const CHECK_FOR_SPECIFIED_PHONE_URL = `${STATIC_FETCH_URL}/sessions/verify/phone`
export const CHECK_FOR_ROOM_URL = `${STATIC_FETCH_URL}/sessions/verify/phone/number`

export const BY_NAME_DIVIDER = '*'

export const TEMP_ROOMS:Array<any> = [
    {
        "_id": "65970b1d70666a32317f813d",
        "firstName": "Artyom",
        "lastName": "Kaplich",
        "phoneNumber": "80259131208",
        "isBooked": false,
        "disabled": false,
        "objectId": "644f973318769b63cf851103",
        "room": {
            "_id": "65095899754549769bac98b9",
            "name": "234",
            "objectId": "644f973318769b63cf851103",
            "type": "Rent bed in room",
            "beds": [
                {
                    "type_id": "644f976318769b63cf851137",
                    "type_name": "bed",
                    "price": "2",
                    "_id": "AUy8AeER",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "4",
                    "_id": "rwM2eO76",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "8",
                    "_id": "ED3S4NpC",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "10",
                    "_id": "d8YogyRw",
                    "peoples": "2"
                }
            ],
            "bedids": [],
            "breakfast": "0",
            "breakfastPrice": 0,
            "breakfastPrice7": 0,
            "breakfastPrice19": 0,
            "disabled": false,
            "__v": 0
        },
        "__v": 0
    },
    {
        "_id": "65970c2370666a32317f8238",
        "firstName": "Artyom",
        "lastName": "Kaplich",
        "phoneNumber": "80259131208",
        "isBooked": false,
        "disabled": false,
        "objectId": "644f973318769b63cf851103",
        "room": {
            "_id": "65095899754549769bac98b9",
            "name": "234",
            "objectId": "644f973318769b63cf851103",
            "type": "Rent bed in room",
            "beds": [
                {
                    "type_id": "644f976318769b63cf851137",
                    "type_name": "bed",
                    "price": "2",
                    "_id": "AUy8AeER",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "4",
                    "_id": "rwM2eO76",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "8",
                    "_id": "ED3S4NpC",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "10",
                    "_id": "d8YogyRw",
                    "peoples": "2"
                }
            ],
            "bedids": [],
            "breakfast": "0",
            "breakfastPrice": 0,
            "breakfastPrice7": 0,
            "breakfastPrice19": 0,
            "disabled": false,
            "__v": 0
        },
        "__v": 0
    },
    {
        "_id": "6597b36c04c516950094187d",
        "firstName": "Artyom",
        "lastName": "Kaplich",
        "phoneNumber": "80259131208",
        "isBooked": false,
        "disabled": false,
        "objectId": "644f973318769b63cf851103",
        "room": {
            "bedids": [],
            "_id": "644f979618769b63cf851153",
            "name": "Zimmer 2",
            "objectId": "644f973318769b63cf851103",
            "type": "Rent bed in room",
            "price": 150,
            "beds": [
                {
                    "type_id": "644f976318769b63cf851137",
                    "type_name": "bed",
                    "price": "50",
                    "_id": "6Ruip6va",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "ZjYk9jnr",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "61VnoREd",
                    "peoples": "2"
                },
                {
                    "type_name": "",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "P6GzE69Z"
                }
            ],
            "breakfast": "1",
            "breakfastPrice": 15,
            "breakfastPrice7": 20,
            "breakfastPrice19": 25,
            "disabled": false,
            "__v": 0
        },
        "booking": {
            "_id": "6597b2ed04c5169500941877",
            "status": "new",
            "objectId": "644f973318769b63cf851103",
            "rooms": [
                {
                    "bedids": [
                        "6Ruip6va",
                        "ZjYk9jnr",
                        "61VnoREd",
                        "P6GzE69Z"
                    ],
                    "_id": "644f979618769b63cf851153",
                    "name": "Zimmer 2",
                    "objectId": "644f973318769b63cf851103",
                    "type": "Rent bed in room",
                    "price": 150,
                    "beds": [
                        {
                            "type_name": "bed",
                            "type_id": "644f976318769b63cf851137",
                            "price": "50",
                            "_id": "ZjYk9jnr",
                            "peoples": "2",
                            "selected": true
                        }
                    ],
                    "breakfast": "1",
                    "breakfastPrice": 15,
                    "breakfastPrice7": 20,
                    "breakfastPrice19": 25,
                    "disabled": false,
                    "__v": 0,
                    "breakfastCount": 0,
                    "firstName": "Artyom",
                    "lastName": "Kaplich",
                    "phoneNumber": "80259131208"
                }
            ],
            "beds": [],
            "dateStart": "2024-01-07T00:00:00.000Z",
            "dateEnd": "2024-01-08T00:00:00.000Z",
            "price": "50",
            "guests": "2",
            "clientId": "644f97c518769b63cf851173",
            "clientSex": "30",
            "workerId": "644f971118769b63cf8510e7",
            "rootId": "644f971118769b63cf8510e7",
            "comment": "",
            "paystatus": "notpaid",
            "arrived": false,
            "disabled": false,
            "archive": false,
            "bedids": [],
            "number": 556033,
            "__v": 0
        },
        "__v": 0
    },
    {
        "_id": "6597c70604c5169500941f12",
        "firstName": "Artyom",
        "lastName": "Kaplich",
        "phoneNumber": "+223344",
        "isBooked": false,
        "disabled": false,
        "objectId": "644f973318769b63cf851103",
        "room": {
            "bedids": [],
            "_id": "644f979618769b63cf851153",
            "name": "Zimmer 2",
            "objectId": "644f973318769b63cf851103",
            "type": "Rent bed in room",
            "price": 150,
            "beds": [
                {
                    "type_id": "644f976318769b63cf851137",
                    "type_name": "bed",
                    "price": "50",
                    "_id": "6Ruip6va",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "ZjYk9jnr",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "61VnoREd",
                    "peoples": "2"
                },
                {
                    "type_name": "",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "P6GzE69Z"
                }
            ],
            "breakfast": "1",
            "breakfastPrice": 15,
            "breakfastPrice7": 20,
            "breakfastPrice19": 25,
            "disabled": false,
            "__v": 0
        },
        "booking": {
            "_id": "6597c70404c5169500941f0f",
            "status": "new",
            "objectId": "644f973318769b63cf851103",
            "rooms": [
                {
                    "bedids": [
                        "6Ruip6va",
                        "ZjYk9jnr",
                        "61VnoREd",
                        "P6GzE69Z"
                    ],
                    "_id": "644f979618769b63cf851153",
                    "name": "Zimmer 2",
                    "objectId": "644f973318769b63cf851103",
                    "type": "Rent bed in room",
                    "price": 150,
                    "beds": [
                        {
                            "type_name": "bed",
                            "type_id": "644f976318769b63cf851137",
                            "price": "50",
                            "_id": "ZjYk9jnr",
                            "peoples": "2",
                            "selected": true
                        }
                    ],
                    "breakfast": "1",
                    "breakfastPrice": 15,
                    "breakfastPrice7": 20,
                    "breakfastPrice19": 25,
                    "disabled": false,
                    "__v": 0,
                    "breakfastCount": 0,
                    "firstName": "Artyom",
                    "lastName": "Kaplich",
                    "phoneNumber": "+223344"
                }
            ],
            "beds": [],
            "dateStart": "2024-02-04T00:00:00.000Z",
            "dateEnd": "2024-02-04T00:00:00.000Z",
            "price": "3",
            "guests": "2",
            "clientId": "64f071d88c24a9745b089c52",
            "clientSex": "30",
            "workerId": "644f971118769b63cf8510e7",
            "rootId": "644f971118769b63cf8510e7",
            "comment": "",
            "paystatus": "notpaid",
            "arrived": false,
            "disabled": false,
            "archive": false,
            "bedids": [],
            "number": 331146,
            "__v": 0
        },
        "__v": 0
    },
    {
        "_id": "6597c77304c5169500941f95",
        "firstName": "Artyom",
        "lastName": "Kaplich",
        "phoneNumber": "+223344",
        "isBooked": false,
        "disabled": false,
        "objectId": "644f973318769b63cf851103",
        "room": {
            "bedids": [],
            "_id": "644f979618769b63cf851153",
            "name": "Zimmer 2",
            "objectId": "644f973318769b63cf851103",
            "type": "Rent bed in room",
            "price": 150,
            "beds": [
                {
                    "type_id": "644f976318769b63cf851137",
                    "type_name": "bed",
                    "price": "50",
                    "_id": "6Ruip6va",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "ZjYk9jnr",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "61VnoREd",
                    "peoples": "2"
                },
                {
                    "type_name": "",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "P6GzE69Z"
                }
            ],
            "breakfast": "1",
            "breakfastPrice": 15,
            "breakfastPrice7": 20,
            "breakfastPrice19": 25,
            "disabled": false,
            "__v": 0
        },
        "booking": {
            "_id": "6597c77104c5169500941f92",
            "status": "new",
            "objectId": "644f973318769b63cf851103",
            "rooms": [
                {
                    "bedids": [
                        "6Ruip6va",
                        "ZjYk9jnr",
                        "61VnoREd",
                        "P6GzE69Z"
                    ],
                    "_id": "644f979618769b63cf851153",
                    "name": "Zimmer 2",
                    "objectId": "644f973318769b63cf851103",
                    "type": "Rent bed in room",
                    "price": 150,
                    "beds": [
                        {
                            "type_name": "bed",
                            "type_id": "644f976318769b63cf851137",
                            "price": "50",
                            "_id": "ZjYk9jnr",
                            "peoples": "2",
                            "selected": true
                        },
                        {
                            "type_name": "bed",
                            "type_id": "644f976318769b63cf851137",
                            "price": "50",
                            "_id": "61VnoREd",
                            "peoples": "2",
                            "selected": true
                        }
                    ],
                    "breakfast": "1",
                    "breakfastPrice": 15,
                    "breakfastPrice7": 20,
                    "breakfastPrice19": 25,
                    "disabled": false,
                    "__v": 0,
                    "breakfastCount": 0,
                    "firstName": "Artyom",
                    "lastName": "Kaplich",
                    "phoneNumber": "+223344"
                }
            ],
            "beds": [],
            "dateStart": "2024-02-11T00:00:00.000Z",
            "dateEnd": "2024-02-11T00:00:00.000Z",
            "price": "3",
            "guests": "4",
            "clientId": "64f071d88c24a9745b089c52",
            "clientSex": "30",
            "workerId": "644f971118769b63cf8510e7",
            "rootId": "644f971118769b63cf8510e7",
            "comment": "",
            "paystatus": "notpaid",
            "arrived": false,
            "disabled": false,
            "archive": false,
            "bedids": [],
            "number": 589477,
            "__v": 0
        },
        "__v": 0
    },
    {
        "_id": "6597f2d2eca12bcf27d7ca91",
        "firstName": "Artyom",
        "lastName": "Kaplich",
        "phoneNumber": "+112233",
        "isBooked": false,
        "disabled": false,
        "objectId": "644f973318769b63cf851103",
        "room": {
            "bedids": [],
            "_id": "644f979618769b63cf851153",
            "name": "Zimmer 2",
            "objectId": "644f973318769b63cf851103",
            "type": "Rent bed in room",
            "price": 150,
            "beds": [
                {
                    "type_id": "644f976318769b63cf851137",
                    "type_name": "bed",
                    "price": "50",
                    "_id": "6Ruip6va",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "ZjYk9jnr",
                    "peoples": "2"
                },
                {
                    "type_name": "bed",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "61VnoREd",
                    "peoples": "2"
                },
                {
                    "type_name": "",
                    "type_id": "644f976318769b63cf851137",
                    "price": "50",
                    "_id": "P6GzE69Z"
                }
            ],
            "breakfast": "1",
            "breakfastPrice": 15,
            "breakfastPrice7": 20,
            "breakfastPrice19": 25,
            "disabled": false,
            "__v": 0
        },
        "booking": {
            "_id": "6597f2c4eca12bcf27d7ca8e",
            "status": "new",
            "objectId": "644f973318769b63cf851103",
            "rooms": [
                {
                    "bedids": [
                        "6Ruip6va",
                        "ZjYk9jnr",
                        "61VnoREd",
                        "P6GzE69Z"
                    ],
                    "_id": "644f979618769b63cf851153",
                    "name": "Zimmer 2",
                    "objectId": "644f973318769b63cf851103",
                    "type": "Rent bed in room",
                    "price": 150,
                    "beds": [
                        {
                            "type_name": "bed",
                            "type_id": "644f976318769b63cf851137",
                            "price": "50",
                            "_id": "ZjYk9jnr",
                            "peoples": "2",
                            "selected": true
                        }
                    ],
                    "breakfast": "1",
                    "breakfastPrice": 15,
                    "breakfastPrice7": 20,
                    "breakfastPrice19": 25,
                    "disabled": false,
                    "__v": 0,
                    "breakfastCount": 0,
                    "firstName": "Artyom",
                    "lastName": "Kaplich",
                    "phoneNumber": "+112233"
                }
            ],
            "beds": [],
            "dateStart": "2024-02-07T00:00:00.000Z",
            "dateEnd": "2024-02-08T00:00:00.000Z",
            "price": "50",
            "guests": "2",
            "clientId": "64f071968c24a9745b089c0c",
            "clientSex": "30",
            "workerId": "644f971118769b63cf8510e7",
            "rootId": "644f971118769b63cf8510e7",
            "comment": "",
            "paystatus": "notpaid",
            "arrived": false,
            "disabled": false,
            "archive": false,
            "bedids": [],
            "number": 376123,
            "__v": 0
        },
        "__v": 0
    }
]